{
  "AboutPage": {
    "get-listed-description": "¿Quieres mostrar tu negocio en Trust Marketplace?",
    "get-listed-suffix": "Para empezar.",
    "get-listed-title": "Obtener listado",
    "how-description": "Comerciantes y particulares verifican su identidad, registro comercial y credenciales a través de la plataforma Raytio. Cada verificación está firmada digitalmente y es auditable de forma independiente, lo que proporciona una cadena de confianza transparente.",
    "how-title": "Cómo funciona la verificación",
    "sign-up": "Regístrate en Raytio",
    "title": "Acerca del Trust Marketplace",
    "what-is-description": "El Mercado de Confianza Raytio es un directorio público de comerciantes y proveedores de servicios verificados. Cada anuncio está respaldado por verificación criptográfica, lo que garantiza que la información que ve es auténtica y confiable.",
    "what-is-title": "¿Qué es el Trust Marketplace?"
  },
  "BookingPage": {
    "book": "Libro",
    "date-range-label": "Próximo",
    "days-label": "días",
    "km-away": "{distancia} km de distancia",
    "location-label": "Ubicación",
    "location-placeholder": "Ingrese el suburbio o la ciudad...",
    "no-results": "No se encontraron citas disponibles. Intente ampliar el radio de búsqueda o el rango de fechas.",
    "progress": "Se buscaron {completados} proveedores {total}",
    "radius-label": "Dentro",
    "search": "Buscar",
    "search-failed": "La búsqueda ha fallado. Por favor, inténtelo de nuevo.",
    "search-timed-out": "La búsqueda ha caducado. Es posible que algunos proveedores no hayan respondido.",
    "searching": "Buscando proveedores...",
    "service-label": "Servicio",
    "service-placeholder": "Seleccione un servicio...",
    "sign-in-prompt": "Inicia sesión con tu cuenta de Raytio para buscar citas disponibles.",
    "sign-in-to-search": "Inicia sesión para buscar",
    "sort-closest": "Más cercano",
    "sort-provider": "Por proveedor",
    "sort-soonest": "Lo antes posible",
    "title": "Reserva una cita",
    "location-permission-denied": "Se denegó el permiso de ubicación. Ingrese una dirección en su lugar.",
    "location-unavailable": "No se pudo determinar su ubicación. Ingrese una dirección en su lugar.",
    "my-location": "Mi ubicación",
    "use-my-location": "Utiliza mi ubicación",
    "sign-up-prompt": "¿No tiene una cuenta? Regístrese para buscar citas disponibles.",
    "sign-up-to-search": "Regístrese para buscar",
    "view-list": "List",
    "view-calendar": "Calendar"
  },
  "CategoryFilter": {
    "clear": "Clear",
    "no-results": "No categories found",
    "placeholder": "Filter by category…"
  },
  "CountryFilter": {
    "all-countries": "Todos los países",
    "filter-by-country": "Filtrar por país"
  },
  "CtaBar": {
    "book": "Libro",
    "coming-soon": "Muy pronto"
  },
  "Footer": {
    "about": "Acerca de",
    "powered-by": "Desarrollado por",
    "privacy": "Privacidad",
    "terms": "Términos"
  },
  "Header": {
    "about": "Acerca de",
    "brand": "Mercado de Raytio",
    "merchants": "Comerciantes",
    "services": "Servicios",
    "sign-in": "Iniciar sesión",
    "sign-out": "desconectar",
    "sign-up": "Registrarse"
  },
  "HomePage": {
    "subtitle": "Descubra comerciantes verificados y proveedores de servicios confiables.",
    "title": "Mercado de confianza",
    "verified-merchants": "Comerciantes verificados",
    "view-all": "Ver todo"
  },
  "MerchantCard": {
    "unnamed": "Comerciante sin nombre",
    "verified": "Verificado"
  },
  "MerchantDetail": {
    "active": "Activo",
    "approved": "Aprobado",
    "default-description": "Ver este comerciante en Raytio Trust Marketplace.",
    "forms-heading": "Formularios",
    "forms-sign-in-button": "Inicia sesión para ver los formularios.",
    "forms-sign-in-prompt": "Inicia sesión con tu cuenta de Raytio para ver los formularios de este comercio.",
    "locations": "Ubicaciones",
    "no-address": "No hay dirección disponible",
    "no-forms-available": "No hay formularios disponibles",
    "not-found": "Comerciante no encontrado",
    "primary-use": "Primario",
    "sign-in-prompt": "Inicie sesión con su cuenta Raytio para ver los detalles de las sucursales y ubicaciones de este comerciante.",
    "sign-in-to-view": "Inicie sesión para ver las ubicaciones",
    "unnamed": "Comerciante sin nombre",
    "forms-sign-up-button": "Regístrese para ver los formularios",
    "forms-sign-up-prompt": "¿No tiene una cuenta? Regístrese para acceder a los formularios de este comerciante."
  },
  "MerchantsPage": {
    "no-merchants": "No se encontraron comerciantes.",
    "subtitle": "Busque comerciantes verificados y proveedores de servicios confiables.",
    "title": "Directorio de comerciantes"
  },
  "SearchBar": {
    "placeholder": "Buscar comerciantes..."
  },
  "ServiceCategoryFilter": {
    "no-results": "No se encontraron categorías",
    "placeholder": "Saltar a una categoría de servicio…"
  },
  "ServiceCategoryPage": {
    "breadcrumb-services": "Servicios",
    "no-merchants": "No se encontraron proveedores para este servicio.",
    "not-found": "Servicio no encontrado",
    "search-placeholder": "Buscar proveedores...",
    "sign-in-prompt": "Inicia sesión con tu cuenta de Raytio para ver los proveedores de este servicio.",
    "sign-in-to-view": "Inicia sesión para ver los proveedores.",
    "sign-up-prompt": "¿No tiene una cuenta? Regístrese para ver los proveedores de este servicio.",
    "sign-up-to-view": "Regístrese para ver proveedores"
  },
  "ServiceItemAttributes": {
    "no-data": "No hay datos de atributos disponibles."
  },
  "ServiceMerchantPage": {
    "breadcrumb-services": "Servicios",
    "hide-details": "Ocultar detalles",
    "items-title": "Productos y servicios",
    "no-items": "No se muestran productos ni servicios.",
    "not-found": "Extraviado",
    "show-details": "Mostrar detalles"
  },
  "ServicesPage": {
    "no-services": "No hay servicios disponibles.",
    "services-count": "{count, plural, one {# servicio} other {# servicios}}",
    "subtitle": "Explora los servicios por categoría.",
    "title": "Servicios"
  },
  "ThemeToggle": {
    "dark-mode": "Cambiar al modo oscuro",
    "light-mode": "Cambiar al modo claro"
  },
  "Persona": {
    "issued": "Issued",
    "expires": "Expires",
    "last-verified": "Last verified",
    "self-asserted-note": "Name and bio are self-asserted and unverified",
    "profile-url": "Profile",
    "claim-verification": "Verification",
    "claim-reputation": "Reputation",
    "section-verifications": "Verifications",
    "section-social": "Connected Accounts",
    "section-reputation": "Reputation",
    "section-other": "Other Claims",
    "no-claims": "This profile has no published claims yet.",
    "rating": "Rating",
    "activity": "Activity",
    "member-since": "Member since",
    "not-found-title": "Profile Not Found",
    "not-found-description": "The requested profile could not be found.",
    "canonical-payload": "Datos firmados",
    "signature": "Firma",
    "signing-key": "Clave de firma",
    "verify": "Verificar firma",
    "verifying": "Verificando…",
    "verify-valid": "Firma válida",
    "verify-invalid": "La firma no coincide",
    "verify-no-key": "No hay clave de firma registrada — no se puede verificar",
    "verify-error": "No se pudo obtener la clave de firma",
    "signed": "Signed",
    "verified": "Verified",
    "view-signed-data": "View signed data",
    "hide-signed-data": "Hide signed data",
    "verify-again": "Verify again",
    "try-again": "Try again",
    "verify-valid-detail": "Checked in your browser against Raytio's published key.",
    "verify-valid-caveat": "A valid signature proves Raytio asserted this — not that it is true or complete.",
    "verify-invalid-detail": "This claim may have been altered.",
    "trust-note": "Each signed claim below carries an RSA-PSS signature from Raytio. Expand one to read the exact bytes that were signed and check them in your own browser — you don't have to take this page's word for anything.",
    "attested-claims-title": "Attested claims",
    "claims-summary": "{count, plural, one {# signed by Raytio · check it yourself} other {# signed by Raytio · check any of them yourself}}",
    "open-profile": "Open profile",
    "trust-note-label": "About attested claims",
    "reputation-note": "Bucketed on purpose — Raytio never publishes exact counts.",
    "stat-activity": "Activity",
    "stat-as-buyer": "As buyer",
    "stat-as-seller": "As seller",
    "stat-reviews": "Reviews",
    "stat-none-yet": "None yet",
    "reputation-note-label": "About these figures"
  },
  "Calendar": {
    "day": "Day",
    "week": "Week",
    "month": "Month",
    "today": "Today",
    "prev": "Previous",
    "next": "Next",
    "all": "All",
    "book": "Book",
    "close": "Close",
    "move": "Move detail window",
    "move-reset": "Move detail window (double-click to snap back)",
    "no-slots-day": "No available slots for this day.",
    "more-slots": "+{count} more",
    "slot-count": "{count, plural, one {# slot} other {# slots}}"
  },
  "BuyPage": {
    "title": "Elige tu sesión",
    "slot-label": "Ranura {slotNumber}",
    "choose-duration": "Selecciona una duración",
    "in-use-title": "Esta ranura está en uso",
    "in-use-body": "Esta ranura tiene una sesión activa en este momento. Vuelve a intentarlo en breve.",
    "halted-title": "Compra en curso",
    "halted-body": "Alguien está completando una compra para esta ranura. Espera un momento e inténtalo de nuevo.",
    "no-options": "No hay opciones disponibles para esta ranura."
  }
}
